const dashboardActionConstants = {
  GET_ACTIVITY_LIST: 'GET_ACTIVITY_LIST',
  GET_ACTIVITY_LIST_SUCCESS: 'GET_ACTIVITY_LIST_SUCCESS',
  GET_ACTIVITY_LIST_ERROR: 'GET_ACTIVITY_LIST_ERROR',

  GET_LEADER_BOARD_LIST: 'GET_LEADER_BOARD_LIST',
  GET_LEADER_BOARD_LIST_SUCCESS: 'GET_LEADER_BOARD_LIST_SUCCESS',
  GET_LEADER_BOARD_LIST_ERROR: 'GET_LEADER_BOARD_LIST_ERROR',

  LIKE_ACTIVITY: 'LIKE_ACTIVITY',
  LIKE_ACTIVITY_SUCCESS: 'LIKE_ACTIVITY_SUCCESS',
  LIKE_ACTIVITY_ERROR: 'LIKE_ACTIVITY_ERROR',

  UNLIKE_ACTIVITY: 'UNLIKE_ACTIVITY',
  UNLIKE_ACTIVITY_SUCCESS: 'UNLIKE_ACTIVITY_SUCCESS',
  UNLIKE_ACTIVITY_ERROR: 'UNLIKE_ACTIVITY_ERROR',

  CHANGE_SELECTED_ORGANIZATION_HOME: 'CHANGE_SELECTED_ORGANIZATION_HOME',

  GET_REWARDS_TERMS_AND_CONDITIONS: 'GET_REWARDS_TERMS_AND_CONDITIONS',
  GET_REWARDS_TERMS_AND_CONDITIONS_SUCCESS: 'GET_REWARDS_TERMS_AND_CONDITIONS_SUCCESS',
  GET_REWARDS_TERMS_AND_CONDITIONS_ERROR: 'GET_REWARDS_TERMS_AND_CONDITIONS_ERROR',

  GET_HOT_JOBS: 'GET_HOT_JOBS',
  GET_HOT_JOBS_SUCCESS: 'GET_HOT_JOBS_SUCCESS',
  GET_HOT_JOBS_ERROR: 'GET_HOT_JOBS_ERROR',

  GET_RECOMMENDED_JOBS: 'GET_RECOMMENDED_JOBS',
  GET_RECOMMENDED_JOBS_SUCCESS: 'GET_RECOMMENDED_JOBS_SUCCESS',
  GET_RECOMMENDED_JOBS_ERROR: 'GET_RECOMMENDED_JOBS_ERROR',

  GET_REFERRAL_RECOMMENDATIONS: 'GET_REFERRAL_RECOMMENDATIONS',
  GET_REFERRAL_RECOMMENDATIONS_SUCCESS: 'GET_REFERRAL_RECOMMENDATIONS_SUCCESS',
  GET_REFERRAL_RECOMMENDATIONS_ERROR: 'GET_REFERRAL_RECOMMENDATIONS_ERROR',

  GET_REFERRAL_LINK: 'GET_REFERRAL_LINK',
  GET_REFERRAL_LINK_SUCCESS: 'GET_REFERRAL_LINK_SUCCESS',
  GET_REFERRAL_LINK_ERROR: 'GET_REFERRAL_LINK_ERROR',
};

export default dashboardActionConstants;
